import CSS_CLASS from '../constants/cssClass'
import TOOLBAR_TYPE from '../constants/toolbarType'
import generateId from '../utils/generateId'
import generateToolbar from '../utils/generateToolbar';

export default function (
  type,
  title,
  previewUrl,
  categories,
  content,
  extraAttrs = [],
  customClass = ''
) {
  const self = this
  const { options } = self
  const snippetId = generateId()

  const template = $(content)

  let localSnippetId = template.data('local-snippet-id') || extraAttrs.find((attr) => attr.indexOf('data-local-snippet-id') !== -1)
  localSnippetId = localSnippetId ? localSnippetId.toString().replace('data-local-snippet-id="', '').replace('"', '') : ''

  let keditorSnippet = template.data('keditor-snippet-id') || extraAttrs.find((attr) => attr.indexOf('data-keditor-snippet-id') !== -1)
  keditorSnippet = keditorSnippet ? keditorSnippet.toString().replace('data-keditor-snippet-id="', '').replace('"', '') : ''

  const toolbar = generateToolbar.call(
      self,
      TOOLBAR_TYPE.BLOCK,
      true
    );

  const preview =
    previewUrl.indexOf('fa fa-') === -1
      ? /* html */ `<span 
  class="${CSS_CLASS.SNIPPET_PREVIEW}" 
  style="background-image: url('${previewUrl}')"></span>`
      : /* html */ `
  <span
    class="${CSS_CLASS.SNIPPET_PREVIEW} text-center d-flex align-items-center justify-content-center"
    style="color: #999;"
  >
    <i class="${previewUrl} fa-3x"></i>
  </span>
  `
  const snippetPreviewHtml = /* html */ `
  <section
    class="${CSS_CLASS.UI} ${CSS_CLASS.SNIPPET} 
    ${type === 'container' ? CSS_CLASS.SNIPPET_CONTAINER : CSS_CLASS.SNIPPET_COMPONENT} ${customClass && customClass} "
    data-snippet="#${snippetId}"
    ${localSnippetId ? `data-local-snippet-id="${localSnippetId}"` : ''}
    ${keditorSnippet ? `data-keditor-snippet-id="${keditorSnippet}"` : ''}
    data-type="${type}"
    data-keditor-title="${title}"
    data-keditor-categories="${categories}"
  >
  <span class="${CSS_CLASS.SNIPPET_INNER}">
      ${preview}
      ${keditorSnippet ? toolbar : ''}
      <span class="${CSS_CLASS.SNIPPET_TITLE}" title="${title}">${title}</span>
    </span>
  </section>
  `
  const snippetContentHtml = `<script id="${snippetId}" type="text/html" ${extraAttrs.join(' ')}>${content}</script>`

  const splitCategories = categories.split(options.snippetsCategoriesSeparator)

  if (type === 'container') {
    self.categoryContainer = self.categoryContainer.concat(splitCategories)
  } else if (type.indexOf('component') !== -1) {
    self.categoryComponent = self.categoryComponent.concat(splitCategories)
  }

  return [snippetPreviewHtml, snippetContentHtml]
}
